<div id="wrap" *ngIf="exercises">
  <div id="reviewBtn" class="fontSize16" (click)="goToVideo()">
    前情动画
  </div>
  <div  [@casePracticeTeamBeginAnimation] class="casePracticeTeamBegin" *ngIf="!completed">
    <div id="text1" class="text fontSize16 lineHeight24">
      轮到你来管理团队了，你想先解决哪个出了问题的因素呢？
    </div>

    <div class="circle fontSize18" id="circle0" (click)="onItemClick(0)" [ngClass]="{'opacity30':exercises[0].status==2}">
      {{exercises[0].name}}
    </div>

    <div class="circle fontSize18" id="circle1" (click)="onItemClick(1)" [ngClass]="{'opacity30':exercises[1].status==2}">
      {{exercises[1].name}}
    </div>

    <div class="circle fontSize18" id="circle2" (click)="onItemClick(2)" [ngClass]="{'opacity30':exercises[2].status==2}">
      {{exercises[2].name}}
    </div>

    <div class="circle fontSize18" id="circle3" (click)="onItemClick(3)" [ngClass]="{'opacity30':exercises[3].status==2}">
      {{exercises[3].name}}
    </div>

    <div class="circle fontSize18" id="circle4" (click)="onItemClick(4)" [ngClass]="{'opacity30':exercises[4].status==2}">
      {{exercises[4].name}}
    </div>

    <div id="text2" class="text fontSize16 lineHeight24">
      你可以自己选择从哪个元素开始，完成5个场景后可以得到报告。
    </div>
  </div>
  <div *ngIf="completed" [@completedAnimation]>
    <img src="{{assetsRoute}}/picture/casepracticeteam/all.png" alt="" id="allPeople">
    <div id="tipBox">
        <div class="fontSize16">
            恭喜你，已经完成了所有的场景挑战，可以查看报告啦~
        </div>
      <div id="tipBoxBtn" (click)='goToReport()' class="fontSize18">
        生成并查看报告
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="videoShow">
  <video [@videoAnimation] width="100%" autoplay id="video">
      <source src="http://video.diaabie.com/Martian_immigrants_20180504.mp4" type="video/mp4">
  </video>
  <img src="{{assetsRoute}}/picture/casepracticeteam/bg.png" id="videoShortCut">
</div> -->



// WEBPACK FOOTER //
// ./src/app/case-practice-team-begin/case-practice-team-begin.component.html